import Skeleton from "@mui/material/Skeleton";

interface TableSkeletonProps {
  numberOfRows?: number;
}

export const TableSkeleton = ({ numberOfRows = 10 }: TableSkeletonProps) => {
  return (
    <>
      {[...Array(numberOfRows)].map((_num: number, index: number) => {
        return <Skeleton animation="wave" key={index} />;
      })}
    </>
  );
};
